if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
				  document.getElementById('site-cart-sidebar').show();
                  const sidebar = document.getElementById('site-cart-sidebar');
                  if (sidebar) {
                    const htmlSnippet = '<a data-js-close="" id="continue-shopping" class="button button--regular button--outline btn-close-drawer" style="margin-top: .5em" title="Continue shopping">Continue shopping</a>';
                    
                    if (sidebar.innerHTML.includes(htmlSnippet)) {
                      console.log("yessnipet");
                      $(document).ready(function() {
                        $(".btn-close-drawer").click(function(e) {
                          e.preventDefault();
                          const closeButton = sidebar.querySelector('button.sidebar__close');
                          if (closeButton) {
                            closeButton.click();
                          }
                        });
                        $('#checkout-button').on('click', function(e) {
                          e.preventDefault();
                          window.location.href= '/cart';
                        });
                      });
                    }
                  }

					if ( document.getElementById('cart-recommendations') ) {
						document.getElementById('cart-recommendations').generateRecommendations();
					}
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
					});
					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
					})
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		init(){

			this.quickViewModal = null;

			this.querySelector('a').addEventListener('click', (e)=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;
					const buttonText = target.querySelector('.button__text');
					const btntext = buttonText.textContent;
					let col_url = window.location.origin + window.location.pathname + window.location.search;
					if (window.location.pathname.includes('/products/')) {
						const parts = window.location.pathname.split('/');
						const collectionIndex = parts.indexOf('collections');

						if (collectionIndex !== -1) {
							const collectionPath = parts.slice(0, collectionIndex + 2).join('/');
							col_url = window.location.origin + collectionPath;
						}
					}

					const coltxt = col_url;
					console.log("quickpop coltxt: ",coltxt);
					localStorage.setItem('coltxt', coltxt);

					target.classList.add('working');
					buttonText.textContent = 'Adding';

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html')
								.querySelector('#product-quick-view');

							const quickViewContainer = document.createElement('div');

							quickViewContainer.innerHTML = `
								<modal-box id="modal-${target.dataset.id}"	
									class="modal modal--product" 
									data-options='{
										"enabled": false,
										"showOnce": false,
										"blockTabNavigation": true
									}'
									tabindex="-1" role="dialog" aria-modal="true">
									<div class="container--medium">
										<div class="modal-content">
											<button class="modal-close" data-js-close data-js-first-focus style="position:absolute;margin:0;top:0;right:0">
												${window.KROWN.settings.symbols.close}
											</button>
										</div>
									</div>
									<span class="modal-background" data-js-close></span>
								</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);

							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							// Load scripts once
							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
								});
								window.productPageScripts = true;
							}

							// Close button
							this.quickViewModal.querySelector('.product-quick-view__close')
								.addEventListener('click', ()=>{
									this.quickViewModal.hide();
								});

							// ✅ FIXED ADD TO CART LOGIC
							const productForm = this.quickViewModal.querySelector('[data-js-product-form]');

							if ( productForm ) {

								productForm.addEventListener('add-to-cart', (e)=>{

									e.preventDefault();

									const formData = new FormData(productForm);
									const variantId = formData.get('id');
									const qtyToAdd = parseInt(formData.get('quantity') || 1);

									// 🔹 STEP 1: Get cart
									fetch('/cart.js')
										.then(res => res.json())
										.then(cart => {

											const existingItem = cart.items.find(item => item.id == variantId);

											let url = '';
											let payload = {};
											let headers = {};

											if (existingItem) {
												// ✅ UPDATE quantity
												url = '/cart/change.js';
												payload = JSON.stringify({
													id: variantId,
													quantity: existingItem.quantity + qtyToAdd
												});
												headers = { 'Content-Type': 'application/json' };

											} else {
												// ✅ ADD new item
												url = '/cart/add.js';
												payload = new URLSearchParams(formData).toString();
												headers = {
													'Content-Type': 'application/x-www-form-urlencoded',
													'X-Requested-With': 'XMLHttpRequest'
												};
											}

											return fetch(url, {
												method: 'POST',
												headers,
												body: payload
											});

										})
										.then(() => {

											// Close modal
											this.quickViewModal.hide();

											// Refresh cart UI
											return fetch('?section_id=helper-cart');

										})
										.then(res => res.text())
										.then(text => {

											const sectionHTML = new DOMParser().parseFromString(text, 'text/html');

											// Update cart items
											const cartContainer = document.getElementById('AjaxCartForm');
											if (cartContainer && sectionHTML.getElementById('AjaxCartForm')) {
												cartContainer.innerHTML =
													sectionHTML.getElementById('AjaxCartForm').innerHTML;

												cartContainer.ajaxifyCartItems();
											}

											// Update subtotal
											const subtotal = document.getElementById('AjaxCartSubtotal');
											if (subtotal && sectionHTML.getElementById('AjaxCartSubtotal')) {
												subtotal.innerHTML =
													sectionHTML.getElementById('AjaxCartSubtotal').innerHTML;
											}

											// Update header counters
											document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
												elm.textContent =
													document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
											});

											document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
												elm.textContent =
													document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
											});

										})
										.catch(err => console.log(err));

								});
							}

							// Show modal + button animation
							setTimeout(()=>{
								this.quickViewModal.show();

								target.classList.add('worksuccess');
								buttonText.textContent = 'Added';

								setTimeout(() => {
									target.classList.remove('working');
									target.classList.remove('worksuccess');
									buttonText.textContent = btntext;
									const $closeBtn = $(".close.quick-view-product-close");
									if ($closeBtn.length) {
										$closeBtn.trigger("click");
									}
									$(document.body).find(".close.quick-view-product-close").trigger("click");
									document.body.classList.add('popup_next_open');
									const modalNext = document.getElementById('nextModal');
									modalNext.style.visibility = 'visible';
									modalNext.style.opacity = '1';

								}, 3000);

							}, 7000);

						});

				} else {
					this.quickViewModal.show();
				}

			});
		}
	}

	if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}
}